export interface IListItemAndPrice {
    name: string;
    price: string;
}